import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import * as gastosFijosApi from "../../api/gastosFijos";

/** Ventana extra para crear/editar un gasto fijo: Motivo + Monto + Día de cobro. */
export default function ModalEditarGastoFijo({ show, onHide, gasto, cuentaId, mes, anio, onGuardado }) {
  const [motivo, setMotivo] = useState("");
  const [monto, setMonto] = useState("");
  const [diaCobro, setDiaCobro] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (show) {
      setMotivo(gasto?.motivo || "");
      setMonto(gasto?.monto ?? "");
      setDiaCobro(gasto?.diaCobro ?? new Date().getDate());
    }
  }, [show, gasto]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await gastosFijosApi.upsertGastoFijo({
        gastoFijoId: gasto?.gastoFijoId ?? null,
        cuentaId,
        motivo,
        monto: Number(monto),
        mes,
        anio,
        diaCobro: Number(diaCobro),
      });
      onGuardado();
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>{gasto ? "Editar gasto fijo" : "Nuevo gasto fijo"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Motivo</Form.Label>
            <Form.Control value={motivo} onChange={(e) => setMotivo(e.target.value)} required autoFocus placeholder="Ej. Alquiler, Internet, Gimnasio..." />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Monto</Form.Label>
            <Form.Control type="number" step="0.01" min="0.01" value={monto} onChange={(e) => setMonto(e.target.value)} required />
          </Form.Group>
          <Form.Group>
            <Form.Label>Día de cobro</Form.Label>
            <Form.Control type="number" min="1" max="31" value={diaCobro} onChange={(e) => setDiaCobro(e.target.value)} required />
            <Form.Text className="text-muted">Día del mes en que vence (1 al 31). Se repite cada mes.</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={guardando}>
            {guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
